import React, {useEffect} from 'react';
import {InputSearch} from "./style/InputStyle";
import styled from "styled-components";


export const Label = styled.span`
  display: ${props => props.mobile ? 'block' : ''};
  margin-right: 10px;
  line-height: 30px;
`;


/**
 * Listener : 검색 실행 메서드
 * setSearchObject : 검색조건을 담아줄 메서드
 * */


function InputSearchText({title, Listener, search, setPageable, placeholder}) {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    useEffect(()=>{
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.shiftKey &&(event.key === 'F' || event.key === 'f')) {
                const this_input = document.getElementById("this_input");
                if (this_input) {
                    this_input.focus();
                }
            }
        };
        // 이벤트 리스너 등록
        document.addEventListener('keydown', handleKeyDown);

        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    },[])

    const inputListener=(e)=>{
        search.fnc((prev) => ({
            ...prev,  //입력값 변경시 searchObject의 다른 값은 초기화 되지 않고 searchTxt만 변경해야 한다
            searchTxt: e.target.value,
        }));
    }

    //통합검색입력후 enter시 바로 검색할 수 있도록
    const handleOnKeyPress = e => {
        if (e.key === 'Enter') {
            // 검색 시 페이지 1번으로 이동
            setPageable((prevSearchObject) => ({
                ...prevSearchObject,
                page: 0
            }));

            Listener();
        }
    };

    return (
        <>

        <Label mobile={isMobile ? "true" : undefined}>{title ? title : '통합검색'}</Label>

        <InputSearch
            mobile={isMobile ? "true" : undefined }
            placeholder={ placeholder ?? "ctrl + shit + F"}
            id={"this_input"} onChange={inputListener} onKeyPress={handleOnKeyPress} ></InputSearch>
        </>
    );
}

export default InputSearchText;